import TaskDetailModal from "./TaskDetailModal";

export default TaskDetailModal;
